import { createBrowserRouter, Navigate } from 'react-router-dom';

// project-imports
import ChartMapRoutes from './ChartMapRoutes';
import ComponentsRoutes from './ComponentsRoutes';
import FormsRoutes from './FormsRoutes';
import OtherRoutes from './OtherRoutes';
import PagesRoutes from './PagesRoutes';
import NavigationRoutes from './NavigationRoutes';
import TablesRoutes from './TablesRoutes';
import AgricolaRoutes from './AgricolaRoutes';
import AdminRoutes from './AdminRoutes';



//import AuthLogin from '../../src/sections/auth/AuthLogin'; // Ajusta la ruta si es necesario
import AuthLogin from '../../src/views/auth/login/Login'
import ProtectedRoute from '../routes/ProtectedRoute'; // El validador de token

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter(
  [
    {
      path: '/login',
      element: <AuthLogin />
    },
    {
      // Grupo protegido: exige token para acceder a cualquiera de estos módulos
      element: <ProtectedRoute />,
      children: [
        AdminRoutes, 
        AgricolaRoutes, 
        NavigationRoutes, 
        ComponentsRoutes, 
        FormsRoutes, 
        TablesRoutes, 
        PagesRoutes, 
        OtherRoutes, 
        ChartMapRoutes
      ]
    },
    {
      path: '*',
      element: <Navigate to="/login" replace />
    }
  ],
  {
    basename: import.meta.env.DEV ? '' : import.meta.env.VITE_APP_BASE_NAME
  }
);

export default router;